(($, Drupal) => {
  "use strict";

  Drupal.behaviors.classStudentStatus = {
    attach(context) {
      // Student table colors based on the assignment status.
      const tableRows = $(".view-school-class-students tbody tr", context);
      if (tableRows.length > 0) {
        tableRows.each(function () {
          const row = $(this);
          const $firstCellSpan = row.find("td:first-child span");

          if ($firstCellSpan.length > 0) {
            const rowClass = `tr__${$firstCellSpan.html()}`;
            row.addClass(rowClass);
          }
        });
      }
    },
  };
})(jQuery, Drupal);
